export default "__VITE_ASSET__DiYw0EzP__"